<template>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Nama Pemasok</th>
        <th scope="col">No. PO</th>
        <th scope="col">No. Surat Jalan</th>
        <th scope="col">Kuantiti</th>
        <th scope="col">Total</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in items"
        :key="item.uuid"
      >
        <td class="text-capitalize">{{ item.supplier_name }}</td>
        <td>{{ item.po_so_id }}</td>
        <td>
          <div v-if="item.delivery_numbers">
            <span v-if="item.delivery_numbers.length < 3">{{
              item.delivery_numbers
                .map((e) => e.delivery_number_note)
                .slice(0, 3)
                .join(', ')
            }}</span>
            <b-dropdown
              v-else
              :text="
                item.delivery_numbers
                  .map((e) => e.delivery_number_note)
                  .slice(0, 3)
                  .join(', ')
              "
              variant="flat-secondary"
              class="delivery-numbers px-0"
            >
              <b-row class="mx-0 pt-1">
                <b-col
                  v-for="(item, index) in data.item.delivery_numbers"
                  :key="index"
                  class=""
                >
                  <h6 class="text-dark">{{ item.delivery_number_note }}</h6>
                </b-col>
              </b-row>
            </b-dropdown>
          </div>
        </td>
        <td>{{ item.qty }}</td>
        <td>{{ formatToRupiah(item.total) }}</td>
      </tr>
    </tbody>
    <tbody v-if="items.length === 0">
      <tr>
        <td
          colspan="4"
          class="text-center"
        >
          Data kosong.
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ReturPurchasing',
  props: ['items'],
  methods: {
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
  },
};
</script>
